import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { UncontrolledTransaction, UncontrolledTransactionListResponse, ParsedImportData, ImportMappingsPayload } from '../models';
import { Observable } from 'rxjs';
import { ObjectResponse, ListResponse, } from '../interfaces';

@Injectable()
export class UncontrolledTransactionsService extends BaseService<UncontrolledTransaction> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  list(queryString?: string): Observable<UncontrolledTransactionListResponse> { return super.list(queryString); }

  uploadUncontrolledTransactionsFile(file: File): Observable<ObjectResponse<ParsedImportData>> {
    const headers = new HttpHeaders();
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<ObjectResponse<ParsedImportData>>(`${this.getResourceUrl()}upload`, formData, { headers });
  }
  
  importUncontrolledTransactionMappings(data: ImportMappingsPayload): Observable<ListResponse<UncontrolledTransaction>> {
    return this.http.post<ListResponse<UncontrolledTransaction>>(`${this.getResourceUrl()}mappings`, data);
  }
  
  getResourceUrl(): string {
    return `${this.baseUrl}uncontrolled-transactions/`;
  }
}
